import PaginationComponent from "components/pagination/Pagination";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Row, Col } from "reactstrap";
import pendingReq from "../../../../../assets/img/icons/customIcons/filter.svg";
import SearchIcon from "../../../../../assets/img/icons/customIcons/searchicondark.svg";

import { setPreClosureRequestInfo } from "redux/actions/admin/PreClosureRequestAction";
import CompanyPreClosureCard from "./CompanyPreClosureCard";
import CustomFilter from "components/customFilter";
function CompanyPreClosureRequestsList({
  handleEmployeeSearchOnChange,
  handleSearch,
  searchFormData,
  data,
  handleClearDate,
  list,
  toggle,
  isDashboard,
  handleSearchOnSelect,
}) {
  const dispatch = useDispatch();
  const [showToggle, setShowToggle] = useState(false);
  const [title, setTitle] = useState("");
  const [isFilter, setIsFilter] = useState(false);
  const [tableHeight, setTableHeigth] = useState(300);

  const pendingPreClosureRequestList = useSelector(
    (state) => state.PendingPreClosureRequestReducer.result
  );
  const pendingPreClosureRequestListLoader = useSelector(
    (state) => state.PendingPreClosureRequestReducer.loader
  );

  useEffect(() => {
    setTitle(data);

    return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  // const clearDate = () => {
  //   const data = { ...searchFormData, fromDate: null, toDate: null };
  //   dispatch(setPreClosureRequestInfo(data));
  // };
  const handlePagination = (tab) => {
    // setSearchFormData({
    //  ...searchFormData,
    //   page: tab,

    // })
    const finalData = {
      ...searchFormData,
      page: tab,
    };

    dispatch(setPreClosureRequestInfo(finalData));
  };
  // eslint-disable-next-line
  useEffect(() => {
    const divElement = document.getElementById("tableDiv");
    if (pendingPreClosureRequestList?.pages?.length > 1) {
      setTableHeigth(divElement.scrollHeight - 72 + "px");
    } else {
      setTableHeigth(divElement.scrollHeight - 12 + "px");
    }
  });
  return (
    <div className="d-flex">
      <Col id="tableDiv" md={isFilter ? "9" : "12"}>
        <Row className="mb-2 second-search">
          <Col md="10">
            <h3 className="tab-title">
              {`${title} (${
                pendingPreClosureRequestList?.itemCount
                  ? pendingPreClosureRequestList?.itemCount
                  : "0"
              })`}{" "}
            </h3>
          </Col>

          <Col md="2" style={{ display: "flex", justifyContent: "flex-end" }}>
            <div className="common-outer-filter">
              {list && (
                <div className="btn-group new-cutom-filter  ">
                  <button
                    type="button"
                    onClick={() => {
                      setShowToggle(!showToggle);
                    }}
                    className={"btn dropdown-toggle mr-3"}
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <img alt="" src={pendingReq} width={"18px"} />
                  </button>
                  <div className="dropdown-menu dropdown-menu-right py-0">
                    {list?.map((item, key) => (
                      <button
                        key={key}
                        className="dropdown-item"
                        onClick={() => toggle(item?.tabId)}
                        type="button"
                        style={{
                          backgroundColor:
                            item?.tabId === "3" ? "#5e72e4" : "none",
                          color: item?.tabId === "3" ? "white" : "none",
                        }}
                      >
                        {item?.title}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              {/* {!isDashboard && (
                <SearchDate
                  handleEmployeeSearchOnChange={handleEmployeeSearchOnChange}
                  handleSearch={handleSearch}
                  clearDate={handleClearDate}
                />
              )} */}
            </div>
            <div className="common-outer-filter">
              <div className="btn-group new-cutom-filter ">
                <button
                  type="button"
                  onClick={() => setIsFilter(!isFilter)}
                  className={"btn dropdown-toggle mr-3"}
                >
                  <img alt="" src={SearchIcon} width={"18px"} />
                </button>
              </div>
            </div>
          </Col>
        </Row>

        <CompanyPreClosureCard loader={pendingPreClosureRequestListLoader} />

        <div
          style={{
            display: pendingPreClosureRequestListLoader ? "none" : "contents",
          }}
        >
          <PaginationComponent
            totalCount={pendingPreClosureRequestList?.itemCount}
            handlePagination={handlePagination}
            activePage={pendingPreClosureRequestList?.activePage}
          />
        </div>
      </Col>
      {/* {isFilter && ( */}
        <Col
          md="3"
          style={{
            height: tableHeight,
            minHeight: "670px",
            display: isFilter ? "block" : "none",
          }}
        >
          <CustomFilter
            tableHeight={tableHeight}
            minHeight={"670px"}
            handleSearchOnSelect={handleSearchOnSelect}
            handleEmployeeSearchOnChange={handleEmployeeSearchOnChange}
            handleSearch={handleEmployeeSearchOnChange}
            type="inbound"
            list={list}
            isFilter={isFilter}
            setIsFilter={setIsFilter}
            handleClearDate={handleClearDate}
          />
        </Col>
      {/* )} */}
    </div>
  );
}

export default CompanyPreClosureRequestsList;
